export const demoRunHref = (href: string): string => {
  const url = new URL(href, 'http://decathlon.local');
  url.searchParams.delete('attract');
  url.searchParams.set('demo', '1');
  return `${url.pathname}${url.search}${url.hash}`;
};

/** Persistent practice-mode entry point shared by all ten event screens. */
export const mountEventDemoLauncher = (): (() => void) => {
  const previous = document.querySelector<HTMLElement>('[data-event-demo-launcher]');
  previous?.remove();

  const active = new URLSearchParams(window.location.search).get('demo') === '1';
  const launcher = document.createElement('a');
  launcher.className = 'event-demo-launcher';
  launcher.dataset.eventDemoLauncher = '';
  launcher.href = demoRunHref(window.location.href);
  launcher.setAttribute(
    'aria-label',
    active ? 'Restart this event demo run' : 'Start an automated successful demo run for this event',
  );

  const eyebrow = document.createElement('small');
  eyebrow.textContent = active ? 'DEMO ACTIVE' : 'NEED A GUIDE?';
  const label = document.createElement('strong');
  label.textContent = active ? '↻ RESTART DEMO' : '▶ DEMO RUN';
  launcher.append(eyebrow, label);
  document.body.append(launcher);

  return () => launcher.remove();
};
